(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2f9e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2f9e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hL2Oe", function(module, exports) {

$parcel$export(module.exports, "register", () => $ced901523d04eab5$export$6503ec6e8aabbaf, (v) => $ced901523d04eab5$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $ced901523d04eab5$export$f7ad0328861e2f03, (v) => $ced901523d04eab5$export$f7ad0328861e2f03 = v);
var $ced901523d04eab5$export$6503ec6e8aabbaf;
var $ced901523d04eab5$export$f7ad0328861e2f03;
"use strict";
var $ced901523d04eab5$var$mapping = new Map();
function $ced901523d04eab5$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ced901523d04eab5$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ced901523d04eab5$var$resolve(id) {
    var resolved = $ced901523d04eab5$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ced901523d04eab5$export$6503ec6e8aabbaf = $ced901523d04eab5$var$register;
$ced901523d04eab5$export$f7ad0328861e2f03 = $ced901523d04eab5$var$resolve;

});

parcelRegister("jV9kF", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", () => $e80a94672eaf0a54$export$bdfd709ae4826697, (v) => $e80a94672eaf0a54$export$bdfd709ae4826697 = v);
var $e80a94672eaf0a54$export$bdfd709ae4826697;
var $e80a94672eaf0a54$export$c9e73fbda7da57b6;
var $e80a94672eaf0a54$export$5a759dc7a1cfb72a;
"use strict";
var $e80a94672eaf0a54$var$bundleURL = {};
function $e80a94672eaf0a54$var$getBundleURLCached(id) {
    var value = $e80a94672eaf0a54$var$bundleURL[id];
    if (!value) {
        value = $e80a94672eaf0a54$var$getBundleURL();
        $e80a94672eaf0a54$var$bundleURL[id] = value;
    }
    return value;
}
function $e80a94672eaf0a54$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $e80a94672eaf0a54$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $e80a94672eaf0a54$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $e80a94672eaf0a54$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$e80a94672eaf0a54$export$bdfd709ae4826697 = $e80a94672eaf0a54$var$getBundleURLCached;
$e80a94672eaf0a54$export$c9e73fbda7da57b6 = $e80a94672eaf0a54$var$getBaseURL;
$e80a94672eaf0a54$export$5a759dc7a1cfb72a = $e80a94672eaf0a54$var$getOrigin;

});

parcelRegister("9YmBA", function(module, exports) {


module.exports = (parcelRequire("hrtMR"))((parcelRequire("hL2Oe")).resolve("9lsZO")).then(()=>parcelRequire("7aH2h"));

});
parcelRegister("hrtMR", function(module, exports) {
"use strict";

var $5Mssz = parcelRequire("5Mssz");
module.exports = $5Mssz(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("5Mssz", function(module, exports) {
"use strict";
var $435782fd140a0f85$var$cachedBundles = {};
var $435782fd140a0f85$var$cachedPreloads = {};
var $435782fd140a0f85$var$cachedPrefetches = {};
function $435782fd140a0f85$var$getCache(type) {
    switch(type){
        case "preload":
            return $435782fd140a0f85$var$cachedPreloads;
        case "prefetch":
            return $435782fd140a0f85$var$cachedPrefetches;
        default:
            return $435782fd140a0f85$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $435782fd140a0f85$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $c914e82e030e8b15$exports = {};


(parcelRequire("hL2Oe")).register((parcelRequire("jV9kF")).getBundleURL("1OTqr"), JSON.parse('["1OTqr","index.b7aaf392.js","9lsZO","lib-fetch.bd9dfb33.js"]'));


var $dHnPu = parcelRequire("dHnPu");

var $jirw5 = parcelRequire("jirw5");

var $hn59j = parcelRequire("hn59j");

var $sl2yL = parcelRequire("sl2yL");
const { byEnvironment: $66d9eab4dfe187bb$var$byEnvironment, ENVIRONMENTS: $66d9eab4dfe187bb$var$ENVIRONMENTS } = (0, $jirw5.environments);
// prestage entries mirror stage: prestage hits stage analytics/launch at runtime.
// preprod entries map to prod values: preprod hits prod APIs/analytics at
// runtime even though the code itself was served from the preprod CDN. The
// iframe-side env-mapper resolves preprod origins to ENVIRONMENTS.prod, so
// these preprod branches are reachable only when something explicitly forces
// the preprod env (currently nothing does, but the byEnvironment map type
// requires the entry).
const $66d9eab4dfe187bb$var$marketingConfig = $66d9eab4dfe187bb$var$byEnvironment((0, $jirw5.envs).getAppEnv);
const $66d9eab4dfe187bb$export$fa54871c0f9704d1 = ()=>$66d9eab4dfe187bb$var$marketingConfig({
        [$66d9eab4dfe187bb$var$ENVIRONMENTS.local]: ()=>"https://assets.adobedtm.com/d4d114c60e50/9893a31a89dc/launch-20e1cb549f8d-development.min.js",
        [$66d9eab4dfe187bb$var$ENVIRONMENTS.stage]: ()=>"https://assets.adobedtm.com/d4d114c60e50/9893a31a89dc/launch-60f5ad31dcdc-staging.min.js",
        [$66d9eab4dfe187bb$var$ENVIRONMENTS.prestage]: ()=>"https://assets.adobedtm.com/d4d114c60e50/9893a31a89dc/launch-60f5ad31dcdc-staging.min.js",
        [$66d9eab4dfe187bb$var$ENVIRONMENTS.preprod]: ()=>"https://assets.adobedtm.com/d4d114c60e50/9893a31a89dc/launch-1b1712458f6e.min.js",
        [$66d9eab4dfe187bb$var$ENVIRONMENTS.prod]: ()=>"https://assets.adobedtm.com/d4d114c60e50/9893a31a89dc/launch-1b1712458f6e.min.js"
    });
const $66d9eab4dfe187bb$export$433df29d39384e33 = ()=>$66d9eab4dfe187bb$var$marketingConfig({
        [$66d9eab4dfe187bb$var$ENVIRONMENTS.local]: ()=>"907a6882-ab0e-470b-b9e2-dacfef7a4b56",
        [$66d9eab4dfe187bb$var$ENVIRONMENTS.stage]: ()=>"907a6882-ab0e-470b-b9e2-dacfef7a4b56",
        [$66d9eab4dfe187bb$var$ENVIRONMENTS.prestage]: ()=>"907a6882-ab0e-470b-b9e2-dacfef7a4b56",
        [$66d9eab4dfe187bb$var$ENVIRONMENTS.preprod]: ()=>"6f975362-e0ca-4f3a-9e2c-8d45aff664ac",
        [$66d9eab4dfe187bb$var$ENVIRONMENTS.prod]: ()=>"6f975362-e0ca-4f3a-9e2c-8d45aff664ac"
    });
window.marketingtech = {
    adobe: {
        launch: {
            url: $66d9eab4dfe187bb$export$fa54871c0f9704d1(),
            controlPageLoad: true
        },
        alloy: {
            edgeConfigId: $66d9eab4dfe187bb$export$433df29d39384e33()
        },
        target: false,
        audienceManager: false
    }
};
function $66d9eab4dfe187bb$var$handleAnalyticsEvents(events) {
    events.forEach((event)=>{
        event.cycle();
    });
}

(parcelRequire("9YmBA")).then(function() {
    var _ref = (0, $dHnPu._)(function*(initialize) {
        // Initialize library code
        yield initialize.default();
        const analyticsStore = (0, $hn59j.getAnalyticsStore)();
        // Set up debounced handler for the events and set loading done
        analyticsStore.setState({
            isAnalyticsLoading: false
        });
        // Handle events that might have accumulated meanwhile
        const appState = yield (0, $hn59j.getApplicationState)();
        const { queryState: { ac: ac, client_id: client_id, locale: locale }, config: { variant: variant } } = appState;
        const analyticsLocaleFormat = locale.replaceAll("_", "-");
        window.alloy_all.set(`${(0, $sl2yL.PAGE_INFO_PROP)}.language`, analyticsLocaleFormat);
        window.alloy_all.set(`${(0, $sl2yL.PAGE_INFO_PROP)}.siteSection`, "IMS-Light");
        window.alloy_all.set(`${(0, $sl2yL.PAGE_INFO_PROP)}.version`, "2.0 Light");
        window.alloy_all.set(`${(0, $sl2yL.IMS_CLIENT_PROP)}.clientID`, client_id);
        if (ac) window.alloy_all.set(`${(0, $sl2yL.IMS_CLIENT_PROP)}.appCodeValue.ac`, ac);
        // Handle all events that have stacked up until now
        const { takeEvents: takeEvents } = analyticsStore.getState();
        $66d9eab4dfe187bb$var$handleAnalyticsEvents(takeEvents());
        // Handle future events
        analyticsStore.subscribe((state)=>{
            const { takeEvents: takeEvents } = state;
            const events = takeEvents();
            if (events.length > 0) $66d9eab4dfe187bb$var$handleAnalyticsEvents(events);
        });
    });
    return function(initialize) {
        return _ref.apply(this, arguments);
    };
}());

})();
//# sourceMappingURL=index.b7aaf392.js.map
